import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {HEADERS} from '../../constants';
import {
    activePlatformAlertsStateActions,
    activePlatformAlertsStateSelector,
} from '../../slices/active-platform-alerts-state.slice';

import type {ActivePlatformAlertsSortField} from '../../typedef';
import type {SortDirection} from 'src/openapi/admin/models/SortDirection';


type Props = {
    sortField: ActivePlatformAlertsSortField,
    columnId: string,
};

export const SortHeader = ({sortField, columnId}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(activePlatformAlertsStateSelector);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        const sortCriteria = {
            direction: direction as SortDirection,
            field: sortField,
        };

        dispatch(activePlatformAlertsStateActions.setSortCriteria(sortCriteria));
    }, [sortField, dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === sortField
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={HEADERS[columnId]}
            onSort={sort}
        />
    );
};
